import { render, staticRenderFns } from "./intelligent.vue?vue&type=template&id=510704f8&scoped=true"
import script from "./intelligent.vue?vue&type=script&lang=js"
export * from "./intelligent.vue?vue&type=script&lang=js"
import style0 from "./intelligent.vue?vue&type=style&index=0&id=510704f8&prod&lang=less&scoped=true"
import style1 from "./intelligent.vue?vue&type=style&index=1&id=510704f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510704f8",
  null
  
)

export default component.exports